import React, { useEffect, useState } from 'react'
import { getObject, getObjectsWithFilter } from '../../api/apiClientCrud'
import { useAuth } from '../../context/AuthContext'

const DocumentPreview = ({ Component, document }) => {
  const { user } = useAuth()
  const [company, setCompany] = useState(null)
  const [logo, setLogo] = useState('')
  const [settings, setSettings] = useState(null)

  useEffect(() => {
    const fetchData = async () => {
      try {
        const companyRes = await getObject('company', user.company_id)
        const companyData = companyRes.data
        setCompany(companyData)

        const logoFile = companyData.attachments?.find((a) => a.type === 'logo')
        if (logoFile?.file?.data) {
          const base64 = btoa(String.fromCharCode(...new Uint8Array(logoFile.file.data)))
          setLogo(base64)
        }

        const settingsRes = await getObjectsWithFilter('settings', { company_id: user.company_id })
        setSettings(settingsRes.data)
      } catch (error) {}
    }

    fetchData()
  }, [user.company_id])

  if (!company || !settings) return null

  return <Component company_param={company} logo_param={logo} settings_param={settings} document_param={document} />
}

export default DocumentPreview
